@if (enrolmentDto) {
  <div class="box ontario-margin-top-32-!">
    <div>
      <h4 class="border-bottom ontario-margin-bottom-24-!">{{'ClassEnrolment.AdministrativeWork' | translate }}</h4>
    </div>
    <app-alert-banner bannerType="alert" bannerText="{{'ClassEnrolment.AdministrativeWorkBanner' | translate}}"></app-alert-banner>
    <div class="field">
      <app-checkbox [checked]="courseFee" (checkedChange)="courseFeeChanged($event)" [name]="'ClassEnrolment.CourseFeeCheckBox' | translate" [disabled]="!isEditMode"></app-checkbox>
    </div>
    <div class="field">
      <app-checkbox [checked]="adminWorkCompleted" (checkedChange)="adminWorkCompletedChanged($event)" [name]="'ClassEnrolment.CompletedCheckBox' | translate" [disabled]="!isEditMode"></app-checkbox>
    </div>
    @if (showEligibility) {
      <div class="field">
        <app-checkbox [checked]="eligibility" (checkedChange)="eligibilityChanged($event)" [name]="'ClassEnrolment.EligibleCheckBox' | translate" [disabled]="!isEditMode"></app-checkbox>
      </div>
    }
  </div>
}
